export default "__VITE_ASSET__Cjd1L8kf__"